import React from 'react'
import {
  AppBar,
  makeStyles,
  Toolbar,
  Typography,
  CardContent,
  Card,
  TextField,
  Select,
} from '@material-ui/core'
import clsx from 'clsx'
import { useIntl } from 'react-intl'
import Assets from 'app/configs/assetConfigs'
import {
  useAutomatedCallSetting,
  initialValuesForm,
} from './useAutomatedCallSetting'
import { Form, Formik } from 'formik'
import {
  retryOptions,
  retryUnitOptions,
  priorityList,
  ALL_DAY,
  DO_NOT_RETYE,
} from './configs'
import { usePlace } from 'commons/usePlace'
import * as R from 'ramda'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import PrimaryButton from 'app/components/buttons/PrimaryButton'
import { addOneHour } from 'libs/dateUtils'

const useStyles = makeStyles((theme) => ({
  panelHeader: {
    backgroundColor: theme.palette.primary.background,
  },
  important: {
    borderColor: '#1F9D55 !important',
  },
  information: {
    borderColor: '#3490DC !important',
  },
  urgent: {
    borderColor: '#F6993F !important',
  },
  emergency: {
    borderColor: '#E3342F !important',
  },
}))

const AutomatedCallSetting = (props) => {
  const { setting, onSuccess, isloading } = props

  const classes = useStyles()
  const { formatMessage } = useIntl()
  const place = usePlace()

  const { times, submit, validationForm } = useAutomatedCallSetting(
    setting,
    onSuccess,
  )

  const priorityOptions = priorityList(
    R.path(['info', 'category', 'allowEmergency'], place),
  )

  const checkAllDay = (form, formLableStartTime, formLableEndTime) => {
    const isAllDay = R.includes(ALL_DAY, [
      form[formLableStartTime],
      form[formLableEndTime],
    ])
    const isEquTime = form[formLableStartTime] === form[formLableEndTime]

    return isAllDay || isEquTime
  }

  return (
    <Card elevation={1} className="flex-auto mb-48">
      <AppBar
        color="default"
        position="static"
        elevation={0}
        className={clsx(classes.panelHeader, 'border-b-1 border-solid')}
      >
        <Toolbar className="ltr:pl-16 rtl:pr-16 ltr:pr-8 rtl:pl-8  title">
          <div className="flex justify-between">
            <div className="flex">
              <img
                src={Assets.channels.automateCallBlack}
                className={classes.iconSize}
                alt="Automate Call"
                width={20}
              />
              <Typography
                variant="h6"
                className="flex-1 font-bold ltr:pl-16 rtl:pr-16"
              >
                {formatMessage({
                  id: 'manageChaanles.automatedCallSetting.header',
                })}
              </Typography>
            </div>
          </div>
        </Toolbar>
      </AppBar>
      <Formik
        enableReinitialize={true}
        initialValues={initialValuesForm(setting)}
        validationSchema={validationForm}
        onSubmit={(values, actions) => {
          actions.setSubmitting(false)
          submit(values)
        }}
      >
        {({
          dirty,
          values,
          setFieldValue,
          isSubmitting,
          handleChange,
          errors,
        }) => (
          <Form>
            <CardContent>
              <div className="md:ml-40">
                <Typography variant="subtitle1" className="font-bold">
                  {formatMessage({
                    id: 'manageChannels.retryOption.header',
                  })}
                </Typography>
                <div className="w-full md:flex md:justify-between my-10">
                  <div className="w-full md:w-1/3 mr-72">
                    <Typography className="font-bold">
                      {formatMessage({
                        id: 'manageChannels.retryOption.title',
                      })}
                    </Typography>
                    <Typography>
                      {formatMessage({
                        id: 'manageChannels.retryOption.description',
                      })}
                    </Typography>
                  </div>
                  <div className="w-full my-10 md:w-2/3 md:flex md:my-0 md:space-x-14">
                    <div className="w-full md:w-1/3 md:px-5">
                      <Select
                        native
                        name="selectedRetry"
                        id="selectedRetry"
                        value={values.selectedRetry}
                        onChange={handleChange}
                        variant="outlined"
                        className="w-full"
                      >
                        {retryOptions.map((option) => {
                          return (
                            <option
                              className="my-10"
                              value={option.value}
                              key={option.id}
                            >
                              {formatMessage({
                                id: option.label,
                              })}
                            </option>
                          )
                        })}
                      </Select>
                    </div>

                    {values.selectedRetry === DO_NOT_RETYE ? null : (
                      <div className="w-full md:w-2/4 my-10 md:my-0 md:none">
                        <div className="mb-10">
                          <div className="w-full flex grid grid-cols-3">
                            <Typography className="w-full flex items-center mx-1 md:mx-0">
                              {formatMessage({
                                id: 'manageChannels.retryOption.start.lable',
                              })}
                            </Typography>
                            <TextField
                              variant="outlined"
                              type="number"
                              className="w-full px-5"
                              name="retryDurationCount"
                              id="retryDurationCount"
                              value={values.retryDurationCount}
                              InputProps={{ inputProps: { min: 1, max: 100 } }}
                              onChange={handleChange}
                            />
                            <Select
                              native
                              value={values.retryDurationUnit}
                              onChange={handleChange}
                              inputProps={{
                                name: 'retryDurationUnit',
                                id: 'retryDurationUnit',
                              }}
                              variant="outlined"
                              className="w-full"
                            >
                              {retryUnitOptions.map((option) => {
                                return (
                                  <option
                                    className="my-10 "
                                    value={option.value}
                                    key={option.value}
                                  >
                                    {formatMessage({
                                      id: option.label,
                                    })}
                                  </option>
                                )
                              })}
                            </Select>
                          </div>
                          <div className="w-full flex grid grid-cols-3">
                            <div className="col-span-1"></div>
                            {errors.retryDurationCount ? (
                              <Typography className="w-full col-span-2 flex items-center text-12 text-red px-5">
                                {errors.retryDurationCount}
                              </Typography>
                            ) : null}
                          </div>
                        </div>

                        <div className="mb-10">
                          <div className="w-full flex grid grid-cols-3">
                            <Typography className="w-full flex items-center mx-1 md:mx-0">
                              {formatMessage({
                                id: 'manageChannels.retryOption.end.lable',
                              })}
                            </Typography>
                            <TextField
                              variant="outlined"
                              type="number"
                              className="w-full px-5"
                              name="retryTimesCount"
                              id="retryTimesCount"
                              value={values.retryTimesCount}
                              InputProps={{ inputProps: { min: 1, max: 100 } }}
                              onChange={handleChange}
                            />
                            <Typography>
                              {formatMessage({
                                id: 'manageChannels.retryOption.occurrences.lable',
                              })}
                            </Typography>
                          </div>
                          <div className="w-full flex grid grid-cols-3">
                            <div className="col-span-1"></div>
                            {errors.retryTimesCount ? (
                              <Typography className="w-full col-span-2 flex items-center text-12 text-red px-5">
                                {errors.retryTimesCount}
                              </Typography>
                            ) : null}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="md:ml-40">
                <Typography variant="subtitle1" className="font-bold">
                  {formatMessage({
                    id: 'manageChannels.allowCall.title',
                  })}
                </Typography>
                <Typography>
                  {formatMessage({
                    id: 'manageChannels.allowCall.description',
                  })}
                </Typography>

                <div className="my-10">
                  {priorityOptions.map((priority) => {
                    return (
                      <div className="w-full md:flex my-10" key={priority.id}>
                        <div
                          className={clsx(
                            classes[priority.id],
                            'border-l-4 w-full md:w-1/3 mr-60 bg-blue-lightest',
                          )}
                          role="alert"
                        >
                          <div className="flex p-16">
                            <img
                              width={20}
                              alt={priority.labelId}
                              src={priority.imgSrc}
                            />
                            <Typography className="font-bold px-10">
                              {formatMessage({
                                id: priority.labelId,
                              })}
                            </Typography>
                          </div>
                        </div>

                        <div className="w-full md:w-1/3 my-5 md:my-0">
                          {checkAllDay(
                            values,
                            priority.formLableStartTime,
                            priority.formLableEndTime,
                          ) ? (
                            <div className="w-full">
                              <FormControl
                                className="w-full"
                                variant="outlined"
                                data-shrink={true}
                                htmlFor={priority.formLableEndTime}
                              >
                                <InputLabel htmlFor="outlined-age-native-simple">
                                  {formatMessage({
                                    id: 'manageChannels.allowCall.start.lable',
                                  })}
                                </InputLabel>
                                <Select
                                  native
                                  value={ALL_DAY}
                                  onChange={(event) => {
                                    setFieldValue(
                                      priority.formLableStartTime,
                                      event.target.value,
                                    )
                                    setFieldValue(
                                      priority.formLableEndTime,
                                      `${addOneHour(event.target.value)}:00`,
                                    )
                                  }}
                                  label="allDay"
                                  variant="outlined"
                                  inputProps={{
                                    name: 'allDay',
                                    id: 'allDay',
                                  }}
                                >
                                  {times.map((item, index) => {
                                    return (
                                      <option key={index} value={item.value}>
                                        {item.label}
                                      </option>
                                    )
                                  })}
                                </Select>
                              </FormControl>
                            </div>
                          ) : (
                            <div className="flex justify-between">
                              <FormControl
                                className="w-full"
                                variant="outlined"
                                data-shrink={true}
                                htmlFor={priority.formLableStartTime}
                              >
                                <InputLabel htmlFor="outlined-age-native-simple">
                                  {formatMessage({
                                    id: 'manageChannels.allowCall.start.lable',
                                  })}
                                </InputLabel>
                                <Select
                                  native
                                  value={values[priority.formLableStartTime]}
                                  onChange={(event) => {
                                    const value = event.target.value
                                    const start = priority.formLableStartTime
                                    const end = priority.formLableEndTime
                                    if (
                                      R.includes(ALL_DAY, [
                                        value,
                                        values[end],
                                      ]) ||
                                      value === values[end]
                                    ) {
                                      setFieldValue(start, ALL_DAY)
                                      setFieldValue(end, ALL_DAY)
                                    } else setFieldValue(start, value)
                                  }}
                                  label="From"
                                  variant="outlined"
                                  inputProps={{
                                    name: priority.formLableStartTime,
                                    id: priority.formLableStartTime,
                                  }}
                                >
                                  {times.map((item, index) => {
                                    return (
                                      <option key={index} value={item.value}>
                                        {item.label}
                                      </option>
                                    )
                                  })}
                                </Select>
                              </FormControl>
                              <div className="mx-10 flex items-center font-bold text-xl">
                                -
                              </div>
                              <FormControl
                                className="w-full"
                                variant="outlined"
                                data-shrink={true}
                                htmlFor={priority.formLableEndTime}
                              >
                                <InputLabel htmlFor="outlined-age-native-simple">
                                  {formatMessage({
                                    id: 'manageChannels.allowCall.end.lable',
                                  })}
                                </InputLabel>
                                <Select
                                  native
                                  value={values[priority.formLableEndTime]}
                                  onChange={(event) => {
                                    const value = event.target.value
                                    const start = priority.formLableStartTime
                                    const end = priority.formLableEndTime
                                    if (
                                      R.includes(ALL_DAY, [
                                        value,
                                        values[start],
                                      ]) ||
                                      value === values[start]
                                    ) {
                                      setFieldValue(start, ALL_DAY)
                                      setFieldValue(end, ALL_DAY)
                                    } else setFieldValue(end, value)
                                  }}
                                  label="Until"
                                  variant="outlined"
                                  inputProps={{
                                    name: priority.formLableEndTime,
                                    id: priority.formLableEndTime,
                                  }}
                                >
                                  {times.map((item, index) => {
                                    return (
                                      <option key={index} value={item.value}>
                                        {item.label}
                                      </option>
                                    )
                                  })}
                                </Select>
                              </FormControl>
                            </div>
                          )}
                        </div>
                      </div>
                    )
                  })}
                </div>
              </div>
            </CardContent>

            <div className="border-t-1 border-solid">
              <CardContent>
                <div className="md:flex md:ml-40">
                  <div className="mr-10 hidden md:block">
                    <img
                      src={Assets.emergency}
                      className="absolute"
                      alt="emergency"
                      width={25}
                    />
                  </div>
                  <div className="mx-10">
                    <Typography>
                      {formatMessage({ id: 'manageChannels.allowCall.noted1' })}
                    </Typography>
                    <Typography>
                      {formatMessage({ id: 'manageChannels.allowCall.noted2' })}
                    </Typography>
                  </div>
                  <div className="my-10 md:my-0">
                    <PrimaryButton
                      className="w-full px-32 py-12"
                      disabled={
                        !dirty ||
                        isSubmitting ||
                        isloading ||
                        !R.isEmpty(errors)
                      }
                      isLoading={isSubmitting}
                      type="submit"
                      labelId={formatMessage({ id: 'saveBtn' })}
                    />
                  </div>
                </div>
              </CardContent>
            </div>
          </Form>
        )}
      </Formik>
    </Card>
  )
}

export default AutomatedCallSetting
